import { defineListFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

export const seniorityDescriptor = defineListFilter({
  definition: {
    id: FilterId.SENIORITY,
    name: 'Seniority',
    selectionListId: 'seniority',
    selections: [],
    type: FilterType.LIST,
    isVisible: true,
  },
  multi: { id: FilterId.MULTI_SENIORITY },
});
